import { useEffect, useState } from 'react';
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner';
import styles from './TipsAndTricks.module.scss';

export type Tip = {
  title: string;
  description: string;
};

type Props = {
  tips: Tip[];
  autoplayDelay?: number;
};

export default function TipsAndTricks({
  tips,
  autoplayDelay = 5000
}: Props) {
  const [currentTipIndex, setCurrentTipIndex] = useState(0);

  useEffect(() => {
    if (tips.length <= 1) return;

    const interval = setInterval(() => {
      setCurrentTipIndex((prevIndex) =>
        prevIndex === tips.length - 1 ? 0 : prevIndex + 1
      );
    }, autoplayDelay);

    return () => clearInterval(interval);
  }, [autoplayDelay, tips.length]);

  if (!tips || tips.length === 0) {
    return (
      <div className={styles.container}>
        <LoadingSpinner className={styles.info} />
        <p className={styles.info}>Loading...</p>
      </div>
    );
  }

  const currentTip = tips[currentTipIndex];

  return (
    <div className={styles.container}>
      <div className={styles.carousel}>
        <div className={styles.slide}>
          <h3 className={styles.tipTitle}>{currentTip.title}</h3>
          <p className={styles.tipDescription}>{currentTip.description}</p>
        </div>
      </div>

      <LoadingSpinner className={styles.info} />
    </div>
  );
}